import { z } from "zod";

export const formSchema = z.object({
    connectionSequenceSteps: z.string(),
});

export type ModifyIncomingPostbackMethodsFormData = z.infer<typeof formSchema>;
